import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb, NavLinkButton } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Panel } from '@admin/components/helpers/panel';
import { List as ContentPanel } from '@admin/components/landing/location/content/list';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { LandingLocationCityQuery, useLandingLocationCityQuery } from '@admin/schema';

const Content: React.FC<{
  city: LandingLocationCityQuery['city'];
}> = ({ city }) => (
  <>
    <Panel>
      <Panel.Body>
        <div>
          State: <strong>{city.state.name}</strong>
        </div>
        <div>
          Region: <strong>{city.region.name}</strong>
        </div>
        <div>
          Slug: <strong>{city.slug}</strong>
        </div>
        <div>
          Name: <strong>{city.name}</strong>
        </div>
        <div>
          Latitude: <strong>{city.latitude}</strong>
        </div>
        <div>
          Longitude: <strong>{city.longitude}</strong>
        </div>
      </Panel.Body>
      <Panel.Footer align="right">
        <NavLinkButton kind="primary" to={`/landing/location/cities/${city.id}/edit`}>
          Edit
        </NavLinkButton>
      </Panel.Footer>
    </Panel>
    <ContentPanel location={city} />
  </>
);

export const Details: React.FC = () => {
  useTitle('Landing - Location - Cities - Details');
  const { id } = useParams<{ id: string }>();
  const { data } = useLandingLocationCityQuery({
    client,
    fetchPolicy: 'cache-and-network',
    variables: { id },
  });
  const city = data?.city;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>Landing</Breadcrumb.Item>
          <Breadcrumb.Item>Location</Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to="/landing/location/cities">Cities</NavLink>
          </Breadcrumb.Item>
          {id && <Breadcrumb.Item active>{city?.name ?? '-'}</Breadcrumb.Item>}
        </Breadcrumb>
      </PageHeader>
      {city ? <Content city={city} /> : <Spinner />}
    </>
  );
};
